import React, { ComponentProps } from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Icon } from 'components/Icon'
import { Link } from 'components/Link'
import { Button } from 'components/Button'
import {
  PremadeMealsRoot,
  Wrapper,
  TextWrapper,
  DesktopImageContainer,
  MobileImageContainer,
  ScrollTopButton,
  ImageBlock,
} from './PremadeMeals.styles'

import premadeMeal from '../../../../../public/assets/wwfr-premade.png'

type PremadeMealsOwnProps = ComponentProps<typeof PremadeMealsRoot>
export type PremadeMealsProps = PremadeMealsOwnProps & {}

export const PremadeMeals = (_props: PremadeMealsProps) => {
  const { t } = useTranslation()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <PremadeMealsRoot>
      <Wrapper>
        <Stack
          direction={{ '@initial': 'column', '@bp2': 'row' }}
          gap={{ '@initial': '0', '@bp2': '8' }}
          alignItems="center"
        >
          <ImageBlock>
            <DesktopImageContainer>
              <Image src={premadeMeal} alt="" />
            </DesktopImageContainer>
          </ImageBlock>
          <TextWrapper>
            <Stack
              direction="column"
              alignItems={{ '@initial': 'center', '@bp2': 'flex-start' }}
              gap="5"
            >
              <Stack direction="column" gap="3">
                <Text
                  size={{ '@initial': 'h3', '@bp2': 'h2' }}
                  as="h2"
                  weight="bold"
                  color="accent-black"
                  align={{ '@initial': 'center', '@bp2': 'left' }}
                >
                  {t('why-we-feed-raw:premade-meals.title')}
                </Text>

                <Text size="headline" color="accent-black">
                  {t('why-we-feed-raw:premade-meals.subtitle')}
                </Text>
              </Stack>
              <MobileImageContainer>
                <Image src={premadeMeal} alt="" />
              </MobileImageContainer>

              <Stack
                direction="column"
                alignItems={{ '@initial': 'center', '@bp2': 'flex-start' }}
                gap="4"
              >
                <Link href="/meal-plan" passHref>
                  <Button as="a">{t('why-we-feed-raw:cta-1')}</Button>
                </Link>
                <Link href="/products" passHref>
                  <Text as="a" size="headline" weight="bold" color="primary-500">
                    {t('why-we-feed-raw:cta-2')}
                  </Text>
                </Link>
              </Stack>
            </Stack>
            <ScrollTopButton onClick={scrollToTop} aria-label={t('home:ending.scrollTop')}>
              <Icon name="arrow-circle-up" color="accent-black"></Icon>
            </ScrollTopButton>
          </TextWrapper>
        </Stack>
      </Wrapper>
    </PremadeMealsRoot>
  )
}

PremadeMeals.displayName = 'PremadeMeals'
